export const MSG_SOMETHING_WRONG = 'Something went wrong, please try again';
